import React from 'react';
import { Menu } from 'antd';
import TEXTS from '../../../locale/texts';

const renderMenuSmsData = ({ lang, addDataHandle }) => {
  return (
    <Menu onClick={addDataHandle}>
      <Menu.Item key="1">
        {TEXTS.dataParam1[lang]}
      </Menu.Item>
      <Menu.Item key="2">
        {TEXTS.dataParam2[lang]}
      </Menu.Item>
      <Menu.Item key="3">
        {TEXTS.dataParam3[lang]}
      </Menu.Item>
      <Menu.Item key="4">
        {TEXTS.dataParam4[lang]}
      </Menu.Item>
    </Menu>
  );
};

export { renderMenuSmsData };
